export default DetalheController;

import * as _ from 'lodash';
import * as angular from 'angular';

/** @ngInject */
function DetalheController($state, $stateParams, Fretes, Navegacao) {

  let vm = this;

  vm.qtFretesRetorno = 0;
  vm.tiposPedagio = Fretes.obterTiposPedagio();
  vm.listarFretesRetorno = listarFretesRetorno;

  buscarFrete();

  function buscarFrete() {
    vm.frete = undefined;
    vm.buscandoFrete = true;

    let filtro = angular.copy(Fretes.obterCache($stateParams.index).filtro || {});

    Fretes
      .buscarFrete($stateParams.nm_base, $stateParams.cd_lote, filtro)
      .then(frete => {
        vm.frete = frete;

        if (filtro.retorno === true) {
          vm.retorno = true;
        }

        vm.buscandoFrete = false;
      })
      .catch(() => {
        Navegacao.voltar();
      });
  }

  function listarFretesRetorno() {

    const filtro: any = _.pick(
      Fretes.obterCache($stateParams.index).filtro,
      ['raio', 'tipoVeiculo', 'tipoCarroceria']
    );

    filtro.retorno = true;
    filtro.origem = {cd_cidade_uf: vm.frete.cd_cidade_destino, id_tipo: 'C'};
    filtro.destino = {cd_cidade_uf: vm.frete.cd_cidade_origem, id_tipo: 'C'};

    Fretes
      .buscarFretes(filtro)
      .then(function (fretes) {
        if (vm.qtFretesRetorno = fretes.length) {
          var index = parseInt($stateParams.index, 10) + 1;
          Fretes.salvarCache(filtro, fretes, index);
          $state.go('consulta.fretes.listagem', {index: index});
        }
      });
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/fretes/detalhe.controller.ts
 **/